import axios from 'axios';
const backendURL = "https://cms-carrosseriemetropool.purplepanda.be";
const namespace = "/wp-json/pp-json";
const url = backendURL + namespace;
let cancelToken;

const get = async (uri)=>{
	const res = await axios.get(`${url}/${uri}`);
	return res.data;
}
const post = async (uri,data)=>{

	const res = await  axios.post(`${url}/${uri}`,JSON.stringify(data),{ cancelToken:cancelToken?.token,headers: { 'content-type': 'application/x-www-form-urlencoded' }});
	return res.data;
}

// Fire-and-forget Zoho webhook call to mirror form submissions
export const sendZohoWebhook = async (payload) => {
	try {
		await axios.post(
			"https://flow.zoho.eu/20110313395/flow/webhook/incoming?zapikey=1001.feae045d1717d377ff44da8efd0d7530.5f4a030a3966fb1562355ec4a9de47f8&isdebug=false",
			payload
		);
	} catch (e) {
		// Do not block the UI or main booking flow if Zoho fails
		// eslint-disable-next-line no-console
		console.error("Zoho webhook error", e);
	}
};


export const getLocations = async ()=>{
	return get(`getLocations`);
}

export const getBrands = async()=>{
	return get('getBrands')
}

export const getSalesEmployee = async(location,dateParam= null, options = {})=>{
let	queryParam = "";
	if(dateParam != null){
		queryParam=`?date=${dateParam}`
	}
	const {allowCancel = true} = options;
	//Check if there are any previous pending requests
	if (allowCancel && typeof cancelToken != typeof undefined) {
		cancelToken.cancel("Operation canceled due to new request.");
	}
	const requestCancelToken = allowCancel ? axios.CancelToken.source() : null;
	if (allowCancel) {
		cancelToken = requestCancelToken;
	}
	return (await axios.get(`${url}/getLocationData/${location}${queryParam}`,{
		cancelToken: requestCancelToken?.token
	})).data;
}

export const sendEmail = async (formData)=>{
	return post(`sendEmails`,formData);
}

export const checkEmployeeAppointment = async (formData)=>{
	return post(`isEmployeeBusy`,formData)
}
export const getCarByCarName = async (carName)=>{
	return get(`getCarByCarName/${carName}`);
}
export const getFooterData = async ()=>{
	return get(`getFooterData`);
}
export const getNextAvailableTime = async(email,date)=>{
	return get(`getNextAvailableTime/${email}?date=${date}`)
}
